// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { PRODUCT_ADD_TO_BAG, OUTFIT_LISTING_FORM } from '@tcp/core/src/constants/reducer.constants';
import { getVideoUrl, isSafariBrowser, getDynamicBadgeQty } from '@tcp/core/src/utils';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { OUTFIT_LABELS, outfitLabels } from '@tcp/core/src/utils/labels/browse/Outfit.labels';
import OutfitProductPropTypes from './OutfitProductPropTypes';
import ProductBasicInfo from '../../../ProductDetail/molecules/ProductBasicInfo/ProductBasicInfo';
import Carousel from '../../../../../common/molecules/Carousel';
import config, { imageData, videoData, videoDataClient } from '../../config';
import ProductPrice from '../../../ProductDetail/molecules/ProductPrice/ProductPrice';
import SIZE_CHART_LINK_POSITIONS from '../../../../../common/molecules/ProductAddToBag/container/ProductAddToBag.config';
import {
  getPrices,
  getMapSliceForColorProductId,
  getProductListToPath,
  getImagesToDisplay,
} from '../../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import ProductAddToBagContainer from '../../../../../common/molecules/ProductAddToBag';
import withStyles from '../../../../../common/hoc/withStyles';
import OutfitProductStyle from '../styles/OutfitProduct.style';
import OutOfStockWaterMarkView from '../../../ProductDetail/molecules/OutOfStockWaterMark';
import { getIconPath, isClient } from '../../../../../../utils';
import InfluencerBadgeHandle from '../../../../../common/atoms/InfluencerBadgeHandle/view/InfluencerBadgeHandle';

const getUpdatedPDPUrl = (pdpToPath, isBundleProduct) => {
  return pdpToPath && `${pdpToPath}&dataSource=${isBundleProduct ? 'bundle' : 'outfit'}`;
};
class OutfitDetailsView extends PureComponent {
  outOfStockCaps = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_COMMON_BROWSE_LABELS}.lbl_common_outOfStockCaps`,
    globalCommonBrowseLabels
  );

  viewDetails = getLabelFromCopyOrFromTranslation(
    `${OUTFIT_LABELS}.lbl_outfit_viewdetail`,
    outfitLabels
  );

  constructor(props) {
    super(props);
    this.formValues = null;
    this.state = {
      selectedSize: '',
      selectedFit: '',
      selectedColor: '',
    };
  }

  static contextType = LabelsContext;

  renderOutOfStock = (keepAlive) => {
    return keepAlive ? <OutOfStockWaterMarkView label={this.outOfStockCaps} /> : null;
  };

  carouselImageCollection = (
    pdpToPath,
    pdpUrl,
    name,
    imagesToDisplay,
    alternateBrand,
    primaryBrand = '',
    isDamImageV2EnabledPDP
  ) => {
    const { influencerTags, isBundleOutfitInfluencerHandleEnabled } = this.props;
    return (
      <>
        <Carousel
          className="carousel-item"
          options={config.CAROUSEL_OPTIONS}
          carouselConfig={{
            autoplay: false,
            customArrowLeft: getIconPath('carousel-big-carrot'),
            customArrowRight: getIconPath('carousel-big-carrot'),
          }}
        >
          {imagesToDisplay &&
            imagesToDisplay.map((image, index) => {
              const imageUrl = image.regularSizeImageUrl;
              const isVideoUrl = imageUrl && getVideoUrl(imageUrl);
              let mainConfig = isVideoUrl ? videoData.imgConfig : imageData.imgConfig;
              mainConfig = isSafariBrowser() && isVideoUrl ? videoDataClient.imgConfig : mainConfig;

              return (
                <Anchor to={pdpToPath} asPath={pdpUrl}>
                  <>
                    <DamImage
                      className="full-size-desktop-image"
                      imgData={{ alt: name, url: imageUrl }}
                      itemProp="contentUrl"
                      imgConfigs={mainConfig}
                      isProductImage
                      isOptimizedVideo={!!isVideoUrl}
                      primaryBrand={primaryBrand || alternateBrand}
                      isDamImageV2EnabledPDP={isDamImageV2EnabledPDP}
                    />
                    <InfluencerBadgeHandle
                      image={imageUrl}
                      influencerTags={influencerTags}
                      isAbOn={isBundleOutfitInfluencerHandleEnabled}
                      index={index}
                      isPreviewImage
                      fromCarousel
                    />
                  </>
                </Anchor>
              );
            })}
        </Carousel>
      </>
    );
  };

  damImageOutfit = (
    images,
    pdpToPath,
    pdpUrl,
    name,
    imagesToDisplay,
    isOnModelAbTestEnabled,
    dynamicBadgeVal
  ) => {
    const { dynamicBadgeOverlayQty, TCPStyleType, isDamImageV2EnabledPDP } = dynamicBadgeVal;
    const { outfitProduct, alternateBrand, influencerTags, isBundleOutfitInfluencerHandleEnabled } =
      this.props;
    const { primaryBrand } = outfitProduct;
    let imageUrl = images.basicImageUrl;
    const isVideoUrl = imageUrl && getVideoUrl(imageUrl);
    let mainConfig = isVideoUrl ? videoData.imgConfig : imageData.imgConfig;
    mainConfig = isSafariBrowser() && isVideoUrl ? videoDataClient.imgConfig : mainConfig;
    if (isOnModelAbTestEnabled && imagesToDisplay && imagesToDisplay.length) {
      // for outfit since we do not show carousel for product images
      // we will show the first on model image in case AB test is ON
      imageUrl = imagesToDisplay[0].regularSizeImageUrl;
    }
    const shouldRenderDamImage = !isVideoUrl || isClient();

    if (shouldRenderDamImage) {
      return (
        <>
          <Anchor to={pdpToPath} asPath={pdpUrl}>
            <>
              <DamImage
                className="full-size-desktop-image"
                imgData={{ alt: name, url: imageUrl }}
                itemProp="contentUrl"
                imgConfigs={mainConfig}
                isProductImage
                isOptimizedVideo={!!isVideoUrl}
                dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
                tcpStyleType={TCPStyleType}
                badgeConfig={imageData.badgeConfig}
                primaryBrand={primaryBrand || alternateBrand}
                isDamImageV2EnabledPDP={isDamImageV2EnabledPDP}
              />
              <InfluencerBadgeHandle
                image={imageUrl}
                influencerTags={influencerTags}
                isAbOn={isBundleOutfitInfluencerHandleEnabled}
                isPreviewImage
                fromCarousel
              />
            </>
          </Anchor>
        </>
      );
    }
    return null;
  };

  imageDisplay = ({
    pageName,
    images,
    pdpToPath,
    pdpUrl,
    name,
    imagesToDisplay,
    isOnModelAbTestEnabled,
    dynamicBadgeOverlayQty,
    TCPStyleType,
    alternateBrand,
    primaryBrand,
    isDamImageV2EnabledPDP,
  }) => {
    return pageName === 'BUNDLE' && imagesToDisplay && imagesToDisplay.length > 1
      ? this.carouselImageCollection(
          pdpToPath,
          pdpUrl,
          name,
          imagesToDisplay,
          alternateBrand,
          primaryBrand,
          isDamImageV2EnabledPDP
        )
      : this.damImageOutfit(
          images,
          pdpToPath,
          pdpUrl,
          name,
          imagesToDisplay,
          isOnModelAbTestEnabled,
          { dynamicBadgeOverlayQty, TCPStyleType, isDamImageV2EnabledPDP }
        );
  };

  isOnModelAbTestActive = (isBundleProduct, isOnModelAbTestBundlePdp, isOnModelAbTestOutfitPdp) => {
    return isBundleProduct ? isOnModelAbTestBundlePdp : isOnModelAbTestOutfitPdp;
  };

  getPdpAsPath = (outfitProduct, selectedPdpUrl, selectedPdpSeoUrl) => {
    const outfitProductPdpUrl = selectedPdpUrl || outfitProduct.pdpUrl;
    const outfitProductPdpSeoUrl = selectedPdpSeoUrl || outfitProduct.seoToken;
    return outfitProduct && outfitProduct.seoToken
      ? `/p/${outfitProductPdpSeoUrl}`
      : outfitProductPdpUrl;
  };

  getColorName = (colorProduct) => colorProduct && colorProduct?.color && colorProduct?.color?.name;

  getPricesForProduct = (outfitProduct, colorProduct, selectedFit, selectedSize) =>
    outfitProduct && getPrices(outfitProduct, colorProduct?.color?.name, selectedFit, selectedSize);

  getProductName = (isBundleProduct, colorProduct) => (isBundleProduct ? colorProduct?.name : '');

  getGroupBadgeLabel = (colorFitsSizesMap = []) =>
    colorFitsSizesMap[0] &&
    colorFitsSizesMap[0].miscInfo &&
    colorFitsSizesMap[0].miscInfo.groupBadgeLabel;

  getDefaultBadge = (badges) =>
    badges && badges.defaultBadge ? badges.defaultBadge : badges.matchBadge;

  getSelectedColorData = (colorFitsSizesMap, selectedColor = {}) => {
    return (
      colorFitsSizesMap &&
      colorFitsSizesMap.filter((colorItem) => {
        const {
          color: { name },
        } = colorItem;
        return (selectedColor.name || selectedColor) === name;
      })
    );
  };

  onChangeSize = (selectedColor, e) => {
    this.setState({
      selectedSize: e,
    });
  };

  onFitChange = (e) => {
    this.setState({
      selectedFit: e,
    });
  };

  onChangeColor = (e) => {
    this.setState({
      selectedColor: e,
    });
  };

  getDynamicBadgeOverlayQty = (isDynamicBadgeEnabled, TCPStyleType, TCPStyleQTY) => {
    return getDynamicBadgeQty(TCPStyleType, TCPStyleQTY, isDynamicBadgeEnabled);
  };

  render() {
    const {
      className,
      outfitProduct,
      productIndexText,
      isCanada,
      isPlcc,
      isInternationalShipping,
      currencySymbol,
      currencyAttributes,
      handleAddToBag,
      addToBagError,
      isLoggedIn,
      addToFavorites,
      isBundleProduct,
      isKeepAliveEnabled,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      pageName,
      isOnModelAbTestBundlePdp,
      isOnModelAbTestOutfitPdp,
      showAddedToBagCta,
      isDynamicBadgeEnabled,
      multiPackThreshold,
      getAllNewMultiPack,
      isInWishList,
      wishList,
      onSetLastDeletedItemIdAction,
      isOutfitPage,
      errorMessages,
      alternateBrand,
      trackWishListClick,
      primaryBrand,
      isHideOriginalPriceAndMarchantTagEnabled,
      outfitItemIndex,
    } = this.props;
    const { selectedSize, selectedFit, selectedColor } = this.state;

    const { extraConfig } = this.context;
    const { isDamImageV2EnabledPDP } = extraConfig || {};

    const { imagesByColor, colorFitsSizesMap, isGiftCard, name, TCPStyleQTY, TCPStyleType } =
      outfitProduct;

    const dynamicBadgeOverlayQty = this.getDynamicBadgeOverlayQty(
      isDynamicBadgeEnabled,
      TCPStyleType,
      TCPStyleQTY
    );
    const selectedColorObject = this.getSelectedColorData(colorFitsSizesMap, selectedColor);
    const selectedColorArray = selectedColorObject && selectedColorObject[0];

    const selectedColorId = !selectedColorArray ? '' : selectedColorArray.colorProductId;
    const selectedPdpUrl = !selectedColorArray ? '' : selectedColorArray.pdpUrl;
    const selectedPdpSeoUrl = !selectedColorArray ? '' : selectedColorArray.pdpSeoUrl;
    const groupBadgeLabel = this.getGroupBadgeLabel(colorFitsSizesMap);
    const colorProduct =
      outfitProduct && getMapSliceForColorProductId(colorFitsSizesMap, selectedColorId);

    const color = this.getColorName(colorProduct);
    const prices = this.getPricesForProduct(outfitProduct, colorProduct, selectedFit, selectedSize);
    const bundleProductName = this.getProductName(isBundleProduct, colorProduct);
    const badges = colorProduct.miscInfo.badge1;
    const badge1 = this.getDefaultBadge(badges);
    const isOnModelAbTestEnabled = this.isOnModelAbTestActive(
      isBundleProduct,
      isOnModelAbTestBundlePdp,
      isOnModelAbTestOutfitPdp
    );

    const imagesToDisplay = getImagesToDisplay({
      imagesByColor,
      curentColorEntry: colorProduct,
      isAbTestActive: isOnModelAbTestEnabled,
      isFullSet: true,
    });

    let pdpAsPath = this.getPdpAsPath(outfitProduct, selectedPdpUrl, selectedPdpSeoUrl);
    pdpAsPath = alternateBrand ? `${pdpAsPath}$brand=${alternateBrand}` : `${pdpAsPath}`;
    const pdpToPath = getProductListToPath(pdpAsPath);
    let newPdpToPath = getUpdatedPDPUrl(pdpToPath, isBundleProduct);
    newPdpToPath = alternateBrand ? `${newPdpToPath}$brand=${alternateBrand}` : `${newPdpToPath}`;
    const images = imagesByColor[color];

    const sizeChartLinkVisibility = !isGiftCard ? SIZE_CHART_LINK_POSITIONS.AFTER_SIZE : null;
    const keepAlive = isKeepAliveEnabled && colorProduct.miscInfo.keepAlive;
    const isHardMarkDown = colorProduct?.hardMarkDown;
    const isHideOriginalPrice = hideProductOriginalPrice(
      isHardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled
    );
    return (
      <>
        <BodyCopy fontSize="fs16" fontFamily="secondary" color="gray.900" fontWeight="extrabold">
          {groupBadgeLabel}
        </BodyCopy>
        <Row className={className}>
          <Col
            colSize={{ small: 6, medium: 3, large: 4 }}
            ignoreGutter={{ small: true }}
            hideCol={{ small: true, medium: true, large: false }}
            className="desktop-image-section"
          >
            <BodyCopy fontSize="fs10" fontFamily="secondary" className="image-section">
              {productIndexText}
            </BodyCopy>
            <BodyCopy component="div" className="image-wrapper">
              {this.imageDisplay({
                pageName,
                images,
                pdpToPath: newPdpToPath,
                pdpUrl: pdpAsPath,
                name,
                imagesToDisplay,
                isOnModelAbTestEnabled,
                dynamicBadgeOverlayQty,
                TCPStyleType,
                alternateBrand,
                primaryBrand,
                isDamImageV2EnabledPDP,
              })}
              {this.renderOutOfStock(keepAlive)}
            </BodyCopy>
            <BodyCopy className="view-detail-anchor">
              <Anchor underline fontSizeVariation="large" to={newPdpToPath} asPath={pdpAsPath}>
                {this.viewDetails}
              </Anchor>
            </BodyCopy>
          </Col>
          <Col
            colSize={{ small: 6, medium: 8, large: 8 }}
            ignoreGutter={{ small: true, medium: true, large: true }}
            className="tablet-product-info"
          >
            <div className="tablet-image-section">
              <BodyCopy fontSize="fs10" fontFamily="secondary" className="image-section">
                {productIndexText}
              </BodyCopy>

              <BodyCopy component="div" className="outfit-mobile-image">
                {this.imageDisplay({
                  pageName,
                  images,
                  pdpToPath: newPdpToPath,
                  pdpUrl: pdpAsPath,
                  name,
                  imagesToDisplay,
                  isOnModelAbTestEnabled,
                  dynamicBadgeOverlayQty,
                  TCPStyleType,
                  alternateBrand,
                  primaryBrand,
                  isDamImageV2EnabledPDP,
                })}
                {this.renderOutOfStock(keepAlive)}
              </BodyCopy>
              <BodyCopy className="view-detail-anchor">
                <Anchor underline fontSizeVariation="large" to={newPdpToPath} asPath={pdpAsPath}>
                  {this.viewDetails}
                </Anchor>
              </BodyCopy>
            </div>
            <div className="product-information">
              <ProductBasicInfo
                isOutfitPage={isOutfitPage}
                keepAlive={keepAlive}
                productInfo={outfitProduct}
                isCanada={isCanada}
                isPlcc={isPlcc}
                pdpUrl={newPdpToPath}
                asPath={pdpAsPath}
                isInternationalShipping={isInternationalShipping}
                onAddItemToFavorites={addToFavorites}
                isLoggedIn={isLoggedIn}
                badge={badge1}
                productMiscInfo={colorProduct}
                AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
                removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
                pageName={pageName || 'OUTFIT'}
                formName={PRODUCT_ADD_TO_BAG}
                hideRating
                bundleProductName={bundleProductName}
                isShowFavoriteCount
                isInWishList={isInWishList}
                onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                wishList={wishList}
                errorMessages={errorMessages}
                primaryBrand={outfitProduct && outfitProduct.primaryBrand}
                trackWishListClick={trackWishListClick}
              />
              <ProductPrice
                isOutfitPage={isOutfitPage}
                currencySymbol={currencySymbol}
                currencyAttributes={currencyAttributes}
                {...prices}
                isCanada={isCanada}
                isPlcc={isPlcc}
                isInternationalShipping={isInternationalShipping}
                promotionalMessage={outfitProduct.promotionalMessage}
                promotionalPLCCMessage={outfitProduct?.promotionalPLCCMessage}
                isAfterPayDisplay
                isHideOriginalPrice={isHideOriginalPrice}
              />
            </div>
            <div className="outfit-sku">
              <ProductAddToBagContainer
                handleFormSubmit={handleAddToBag}
                currentProduct={outfitProduct}
                isOutfitPage={isOutfitPage}
                errorOnHandleSubmit={addToBagError}
                isBundleProduct={isBundleProduct}
                sizeChartLinkVisibility={sizeChartLinkVisibility}
                isKeepAliveEnabled={isKeepAliveEnabled}
                onChangeColor={this.onChangeColor}
                onChangeSize={this.onChangeSize}
                onFitChange={this.onFitChange}
                customFormName={OUTFIT_LISTING_FORM}
                showAddedToBagCta={showAddedToBagCta}
                multipackProduct={outfitProduct.newPartNumber}
                multiPackThreshold={multiPackThreshold}
                getAllNewMultiPack={getAllNewMultiPack}
                isInWishList={isInWishList}
                primaryBrand={outfitProduct && outfitProduct.primaryBrand}
                outfitItemIndex={outfitItemIndex}
              />
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

OutfitDetailsView.propTypes = OutfitProductPropTypes;

OutfitDetailsView.defaultProps = {
  className: '',
  outfitProduct: {},
  selectedProductId: '',
  productIndexText: '',
  isCanada: false,
  isPlcc: false,
  currencySymbol: 'USD',
  addToBagError: false,
  isLoggedIn: false,
  isBundleProduct: false,
  isKeepAliveEnabled: false,
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  pageName: '',
  isOnModelAbTestBundlePdp: false,
  isOnModelAbTestOutfitPdp: false,
  showAddedToBagCta: '',
  isDynamicBadgeEnabled: false,
  getAllNewMultiPack: {},
  onSetLastDeletedItemIdAction: () => {},
  wishList: {},
  isOutfitPage: false,
};

export default withStyles(errorBoundary(OutfitDetailsView), OutfitProductStyle);
